import { memo } from "react";
import { TableSearch } from "ui/components/Table/TableSearch";
import { initialDataWithPagination } from "services/api/consts";
import { useTranslate } from "helpers";
import {
  FLEET_TIRE_SET_DOCUMENT_SEARCH_COLUMNS,
  FLEET_TIRE_SET_DOCUMENT_UPLOADS_SEARCH_COLUMNS,
} from "./consts";
import { TireSetDocumentSearchResultsProps } from "./types";
import VehicleDocumentRowChild from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleDocumentCard/components/VehicleDocumentSearchResults/components/VehicleDocumentRowChild";

const TireSetDocumentSearchResults: React.FC<TireSetDocumentSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  return (
    <TableSearch
      columns={FLEET_TIRE_SET_DOCUMENT_SEARCH_COLUMNS(t, onDeleteClick)}
      data={searchResults.data}
      selectedRows={selectedRows}
      pagination={
        searchResults.pagination || initialDataWithPagination.pagination
      }
      selectableRows={false}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange}
      isLoading={isLoading}
      onRowClick={onRowClick}
      columnsChild={FLEET_TIRE_SET_DOCUMENT_UPLOADS_SEARCH_COLUMNS(t)}
      CustomTableRowChild={(childProps) => (
        <VehicleDocumentRowChild
          {...childProps}
          onFetchSearchResult={() =>
            onPaginationChange?.(searchResults.pagination)
          }
        />
      )}
    />
  );
};

export default memo(TireSetDocumentSearchResults);
